/**
 * 取得済み登記（requested-pictures）用の備考同期システム
 * PropertySelectionGridと取得済み登記ポップアップ間で備考データを同期するためのユーティリティ
 */

import { createPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const REQUESTED_PICTURES_REMARKS_UPDATE_EVENT =
  "updateRequestedPicturesRemarks";

const { dispatch, addListener } = createPropertyGridPopupSyncSystem<string>(
  REQUESTED_PICTURES_REMARKS_UPDATE_EVENT
);

/**
 * 取得済み登記の備考更新イベントを発火する
 * @param remarks 更新する備考
 */
export const dispatchRequestedPicturesRemarksUpdate = (
  remarks: string
): void => {
  dispatch(remarks);
};

/**
 * 取得済み登記の備考更新イベントリスナーを追加する
 * @param callback 備考が更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addRequestedPicturesRemarksUpdateListener = (
  callback: (remarks: string) => void
): (() => void) => {
  return addListener(callback);
};
